import instance from "../root.api";

export const loginRequest = ({ identifier, password }) =>
  instance
    .post(`/auth/admin-login`, { identifier, password })
    .then(response => ({ response }))
    .catch(response => ({ ...response }));
